import { createFileRoute } from '@tanstack/react-router';

import { PartnerDetailView } from '../../../features/partners/partner-detail';
import { partnerDetailQueryOptions } from '../../../features/partners/queries';

export const Route = createFileRoute('/admin/partners/$partnerId')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { partnerId } = match.params as { partnerId: string };
      const data = queryClient.getQueryData(partnerDetailQueryOptions(partnerId).queryKey);
      return data?.partner_display_name ?? data?.partner_name ?? null;
    },
  },
  component: PartnerDetailView,
});
